import IntroWizardsCover from '@/components/intro-wizards/intro-wizards-cover/intro-wizards-cover';
import { Text } from '@cmpsr/components';

type ModalIntroWizardCoverProps = {
  onNextButtonClick: () => void;
  onBackButtonClick: () => void;
};

export default function ModalIntroWizardCover(props: ModalIntroWizardCoverProps) {
  return (
    <IntroWizardsCover
      titleNode={
        <Text as="h1" variant="text-header-XL" color="text-light">
          {' '}
          Welcome to your Annual{' '}
          <Text as="span" textStyle="text-header-xl-v" color="text-light !important">
            Testing Plan!
          </Text>
        </Text>
      }
      descriptionNode={
        <Text variant={{ base: 'text-body-meta-regular', lg: 'text-body-regular' }} color="text-light">
          This is your{' '}
          <Text as="span" fontWeight="600" color="text-light" fontStyle="italic">
            comprehensive annual testing protocol
          </Text>{' '}
          based on your unique risk profile for 21 top cancers. As a Catch member, your Annual Testing Plan will{' '}
          <Text as="span" fontWeight="600" color="text-light" fontStyle="italic">
            update each year
          </Text>{' '}
          based on your latest data, as well as advancements in testing options.
        </Text>
      }
      icon="test-options-light"
      onNextButtonClick={props.onNextButtonClick}
      onBackButtonClick={props.onBackButtonClick}
    />
  );
}
